import Account from 'assets/Icons/Account/Account';
import { ChildrenType } from 'models/Common/commonTypes';
import { ReactElement } from 'react';
import styled from 'styled-components';
import { BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { Body3Regular, Body3SemiBold, Body4Medium, Body5Regular } from 'styles/Global/typography';

type ProfileProps = {
    name: string;
    subText: string;
    firstLabel: string;
    firstLabelText: string;
    secondLabel: string;
    secondLabelText: string;
    thirdLabel: string;
    thirdLabelText: ReactElement;
    gender: ReactElement;
};
export const Profile = ({ name, subText, firstLabel, firstLabelText, secondLabel, secondLabelText, thirdLabel, thirdLabelText, gender }: ProfileProps) => {
    return (
        <ProfileLayout>
            <NameContainer>
                <Account />
                <NameArea name={name} subText={subText} gender={gender} />
            </NameContainer>
            <TextContainer>
                <LabelAndText label={firstLabel} text={firstLabelText} />
                <LabelAndText label={secondLabel} text={secondLabelText} />
                <LabelAndText label={thirdLabel} text={thirdLabelText} />
            </TextContainer>
        </ProfileLayout>
    );
};

export default Profile;

const ProfileLayout = ({ children }: ChildrenType) => {
    return <Layout>{children}</Layout>;
};

const NameContainer = ({ children }: ChildrenType) => {
    return <NameAreaContainer>{children}</NameAreaContainer>;
};

const NameArea = ({ name, subText, gender }: { name: string; subText: string; gender: ReactElement }) => {
    return (
        <NameAreaWrapper>
            <Name>{name}</Name>
            {gender}
            <SubText>{subText}</SubText>
        </NameAreaWrapper>
    );
};

const TextContainer = ({ children }: ChildrenType) => {
    return <TextAreaContainer>{children}</TextAreaContainer>;
};

const LabelAndText = ({ label, text }: { label: string; text: string | ReactElement }) => {
    return (
        <LabelAndTextWrapper>
            <Label>{label}</Label>
            <Text>{text}</Text>
        </LabelAndTextWrapper>
    );
};

const Layout = styled.div`
    display: flex;
    flex-direction: column;
    padding: 18px 20px 18px 20px;
    gap: 12px;
    width: 448px;
    height: 200px;
    border: 1px solid ${BorderColor.color_border_neutral};
    border-radius: ${Radius.radius_4};
`;

const NameAreaContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    height: 24px;
`;

const NameAreaWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    width: 100%;
    height: 100%;
`;

const Name = styled(Body3SemiBold)``;

const SubText = styled(Body3Regular)``;

const TextAreaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    height: 126px;
    background-color: ${BackgroundColor.color_background_light};
    padding: 18px 20px;
`;

const LabelAndTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    height: 20px;
`;

const Label = styled(Body5Regular)`
    width: 60px;
    color: ${TextColor.color_text_light};
`;

const Text = styled(Body4Medium)``;
